import useSWR from "swr"
import { PickingShortageApi } from "../../../apis"

export function useShortageDecisionQuery(pullSheetId: string | null | undefined) {
  return useSWR(
    pullSheetId ? ["pull-sheet-decision", pullSheetId] : null,
    async () => PickingShortageApi.getDecision(pullSheetId as string),
    { revalidateOnFocus: false },
  )
}
